import { DeepPartial, PortalHeaderMenuAlign, PortalThemeConfig, PortalThemeKeys } from '@nx-frontend/shared/types';

type PortalThemePreset = Omit<DeepPartial<PortalThemeConfig>, 'colors'> & { key: PortalThemeKeys };

export const portalThemePresets: PortalThemePreset[] = [
  {
    key: 'wedding_1',
    header: {
      menu: { align: PortalHeaderMenuAlign.CENTER },
    },
  },
  {
    key: 'wedding_2',
    header: {
      menu: { align: PortalHeaderMenuAlign.CENTER },
    },
  },
  {
    key: 'the_fusebase',
    header: {
      menu: { align: PortalHeaderMenuAlign.CENTER },
      className: ['p-2'],
    },
    hero: { className: ['p-8'] },
  },
  {
    key: 'sketchy_digital',
    style: {
      radius: {
        className: ['rounded-xl'],
      },
    },
  },
];

export const portalThemePresetByKey = (key: PortalThemeKeys): PortalThemePreset | undefined => {
  const index = portalThemePresets.findIndex((preset) => preset.key === key);
  return index !== -1 ? portalThemePresets[index] : undefined;
};
